export default __webpack_public_path__ + "images/XT.d43259b.png";